export enum EPeriod {
  All = "all",
  Last30Days = "30D",
  Last60Days = "60D",
  Last90Days = "90D",
  LastYear = "1A",
}

export enum EDiary {
  Accumulated = "Accumulated",
  Daily = "Daily",
  AccumulatedPercenteg = "AccumulatedPercenteg",
  DailyPercenteg = "DailyPercenteg",
}

export enum EIsBackTest {
  "All" = "",
  False = "false",
  True = "true",
}
